import { useEffect, useState } from "react";
import axios from "axios";
import { getApiHeaders } from "../utils/helpers";
import { BASE_URL } from "../api";
import { useHandleError } from "./useHandleError";

export default function useIbStatus(mid) {
    const [ibStatus, setIbStatus] = useState("");
    const [ibLoading, setIbLoading] = useState(false);
    const handleError = useHandleError();

    const getIbStatus = async () => {
        setIbLoading(true);

        const inputBody = {};
        // const inputBody = { mid: Number(mid) };

        try {
            const res = await axios.get(
                `${BASE_URL}/IB/check_ib_request_status`,
                { headers: getApiHeaders() }
            );

            if (res.data.code === 200) {
                const raw = String(res.data.data[0]?.status || "").toLowerCase().trim();
                setIbStatus(raw || "not_applied");
            } else {
                setIbStatus("not_applied");
            }
        } catch (error) {
            if (
                error.response?.status === 400 &&
                error.response?.data?.message?.msg === "Mid not found"
            ) {
                setIbStatus("not_applied");
            } else {
                handleError(error);
            }
        } finally {
            setIbLoading(false);
        }
    };

    useEffect(() => {
        getIbStatus();
    }, []);

    const s = String(ibStatus || "").toLowerCase().trim();

    return {
        ibStatus,
        ibLoading,
        refreshIbStatus: getIbStatus,
        isPending: s === "pending",
        isActive: ["active", "approve", "approved"].includes(s),
        isRejected: ["reject", "rejected"].includes(s),
        isNotApplied: s === "not_applied" || !s,
    };
}

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { getApiHeaders } from "../utils/helpers";
// import { BASE_URL } from "../api";
// import { useHandleError } from "./useHandleError";

// export default function useIbStatus(mid) {
//     const [ibStatus, setIbStatus] = useState("");
//     const [ibLoading, setIbLoading] = useState(false);
//     const handleError = useHandleError();

//     const getIbStatus = async () => {
//         setIbLoading(true);

//         const inputBody = {};
//         // const inputBody = { mid: Number(mid) };

//         try {
//             const res = await axios.post(
//                 `${BASE_URL}/IB/check_ib_request_status`,
//                 inputBody,
//                 { headers: getApiHeaders() }
//             );

//             if (res.data.code === 200) {
//                 setIbStatus(res.data.data[0]?.status?.toLowerCase());
//             } else {
//                 setIbStatus("not_applied");
//             }
//         } catch (error) {
//             if (
//                 error.response?.status === 400 &&
//                 error.response?.data?.message?.msg === "Mid not found"
//             ) {
//                 setIbStatus("not_applied");
//             } else {
//                 handleError(error);
//             }
//         } finally {
//             setIbLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (mid) getIbStatus();
//     }, [mid]);

//     return {
//         ibStatus,
//         ibLoading,
//         refreshIbStatus: getIbStatus,
//         isPending: ibStatus === "pending",
//         isActive: ibStatus === "active",
//         isNotApplied: ibStatus === "not_applied",
//     };
// }
